<template>
  <div
    v-if="opportunityBeingVisited.project.isActive"
    id="projects-info"
    class="container"
  >
    <div class="columns">
      <div id="projects-box" class="column box">
        <projects-title
          title="Parceria para Projetos"
          buttonText="Solicitar"
          :description="description"
          :isCardOpen="isCardOpen"
          @open-card="$emit('open-card', 'project')"
          @close-card="$emit('close-card', 'project')"
        />

        <div class="columns action-details" v-if="isCardOpen">
          <themes :themes="opportunityBeingVisited.project.themes" />

          <prerequisites
            :minPublic="opportunityBeingVisited.project.minPublic"
            :maxPublic="opportunityBeingVisited.project.maxPublic"
            :advance="opportunityBeingVisited.project.advance"
            :limitDateForRequests="opportunityBeingVisited.limitDateForRequests"
            :limitDateForActions="opportunityBeingVisited.limitDateForActions"
            :courses="opportunityBeingVisited.project.courses"
            :states="opportunityBeingVisited.project.states"
          />

          <project-counterparts
            :treatmentPronoun="opportunityBeingVisited.treatmentPronoun"
            :businessName="opportunityBeingVisited.businessName"
            :logosZipURL="opportunityBeingVisited.page.logosZipURL"
          />
        </div>
      </div>
    </div>

    <b-modal :active.sync="isRequestModalActive">
      <project-request-modal
        :advance="opportunityBeingVisited.project.advance"
      />
    </b-modal>
  </div>
</template>

<script>
import { descriptions } from "../../../assets/js/actions-descriptions";
import projectsTitle from "./card/Title";
import themes from "./card/Themes";
import prerequisites from "./card/Prerequisites";
import projectCounterparts from "./card/ProjectCounterparts";
import projectRequestModal from "../request-modal/ProjectRequestModal";

export default {
  props: ["opportunityBeingVisited", "isCardOpen"],

  components: {
    projectsTitle,
    themes,
    prerequisites,
    projectCounterparts,
    projectRequestModal
  },

  data() {
    return {
      description: "",
      isRequestModalActive: false
    };
  },

  mounted() {
    this.description = descriptions.project;
  }
};
</script>

<style scoped>
#projects-info {
  margin-top: 3rem;
}
@media (max-width: 1023px) {
  #projects-info {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
}
#projects-box {
  background-color: rgb(242, 242, 242);
}
.action-details {
  padding: 2rem;
}
</style>
